import React from 'react';
import { Box, Text, SimpleGrid, Divider } from '@chakra-ui/react';
import { formatDate } from '../../utils/dates';
import { servicebookingFlowStore } from '../../store/ServiceBookingFlowStore';
import { bookingFlowStore } from '../../store/BookingFlowStore';
import { patientStore } from '../../store/PatientStore';
interface AppointmentDetailsProps {
  patient: any;
  selectedTime: any;
  doctor: any;
  clinic: any;
}

export const AppointmentDetails: React.FC<AppointmentDetailsProps> = ({
  patient,
  selectedTime,
  doctor,
  clinic
}) => {
  return (
    <Box width={{ base: "100%", md: "50%" }} mt={5}>
      <Text fontSize="md">Check and make sure all information is correct.</Text>
      <Text fontSize="sm" mt={7} fontWeight="bold">Personal Details</Text>
      <SimpleGrid columns={2} spacing={3} mt={5}>
        <Text fontSize="sm">Full Name {patientStore?.currentPatient.id}</Text>
        <Text fontSize="sm" fontWeight="bold">
          {patient.first_name || 'N/A'} {patient.last_name || 'N/A'}
        </Text>
        <Text fontSize="sm">Date of Birth</Text>
        <Text fontSize="sm" fontWeight="bold">{patient.dob || 'N/A'}</Text>
      </SimpleGrid>
      <Divider mt={7} />
      <Text fontSize="sm" mt={7} fontWeight="bold">Appointment Details</Text>
      <SimpleGrid columns={2} spacing={3} mt={5}>
        <Text fontSize="sm">Date</Text>
        <Text fontSize="sm" fontWeight="bold">
          {selectedTime?.date ? formatDate(selectedTime.date) : 'N/A'}
        </Text>
        <Text fontSize="sm">Time</Text>
        <Text fontSize="sm" fontWeight="bold">{selectedTime?.formattedTime || 'N/A'}</Text>
        <Text fontSize="sm">Booked Doctor</Text>
        <Text fontSize="sm" fontWeight="bold">{doctor?.display_name || 'N/A'}</Text>
        <Text fontSize="sm">Appointment type</Text>
        <Text fontSize="sm" fontWeight="bold">
          {servicebookingFlowStore?.appointmentData?.appointmentType?.display_name || 
           bookingFlowStore.appointmentData.appointmentType?.display_name}
        </Text>
        <Text fontSize="sm">Clinic Name</Text>
        <Text fontSize="sm" fontWeight="bold">
          {doctor?.location_display_name || clinic?.centre_name}
        </Text>
      </SimpleGrid>
    </Box>
  );
};